import React, { useEffect, useState } from "react";
import { useWizard } from "react-use-wizard";
import NavigateBack from "../../components/navigateBack";
import DOB from "../../components/dob";
import { useTranslation } from "react-i18next";

function DOBInputStep({
  qKey,
  onSubmitHandler,
  state,
  userName,
  prevWizardStep,
}) {
  const { previousStep, nextStep, goToStep } = useWizard();
  const _qKey = qKey;
  const [dobValue, setDOBValue] = useState(
    state && state.hasOwnProperty("date") ? state["date"] : ""
  );
  const [age, setAge] = useState(
    state && state.hasOwnProperty("age") ? state["age"] : null
  );
  const [isGuardianConsentProvided, setGuardianConsentProvided] =
    useState(false);
  const [canProceed, setCanProceed] = useState(false);
  const { t } = useTranslation();

  const onNextFn = (data) => {
    if (prevWizardStep) {
      onSubmitHandler({ [_qKey]: data }, true);
    } else {
      onSubmitHandler({ [_qKey]: data });
    }
    nextStep();
  };

  const updateValue = (data) => {
    console.log(data);
    setDOBValue(data);
  };

  const goBack = () => {
    const ps = prevWizardStep();
    console.log(ps);
    if (ps !== -1) {
      goToStep(ps);
    } else {
      previousStep();
    }
  };

  const handleGuardianConsentState = (e) => {
    setGuardianConsentProvided(e.target.checked);
  };

  useEffect(() => {
    const _state =
      (dobValue !== "" || dobValue != null) &&
      ((age < 18 && isGuardianConsentProvided) || age >= 18);
    setCanProceed(_state);
  }, [dobValue, isGuardianConsentProvided, age]);

  useEffect(() => {
    if (dobValue) {
      const currentYear = new Date().getFullYear();
      setAge(currentYear - dobValue.split("/")[0]);
    } else {
      setAge(null);
    }
  }, [dobValue]);

  return (
    <>
      <NavigateBack onClickHandler={() => goBack()} />
      <div className="body_content">
        <div className="inner_body ">
          <h3 className="headtitle ">
            {/* {`Thank you, ${userName}. What is your Age?`} */}
            {t("login.DOBSTEP.thanku")},&nbsp;
            <span style={{ textTransform: "capitalize" }}>{userName}.</span>

            <br/>
             
            {t("login.DOBSTEP.personalDetailsMessage")}
             
            <br/>
            <br /> {t("login.DOBSTEP.dob")}

          </h3>
        
          <div className="fill_form light_fill_form">
            <DOB
              initValue={{ date: dobValue, age: age }}
              onChange={updateValue}
            />
          </div>
          {age !== null && age < 18 && (
            <>
              <div className="txt" style={{ marginTop: "3em" }}>
                {t("login.DOBSTEP.isMinorPrompt")}
              </div>
              <div className="form-check" style={{ marginTop: "1em" }}>
                <input
                  type="checkbox"
                  className="form-check-input checkboxTerms "
                  id="check1"
                  name="option1"
                  value={isGuardianConsentProvided}
                  onChange={handleGuardianConsentState}
                />
                <span className="txt">
                  {t("login.DOBSTEP.isMinorPromptCTA")}
                </span>
              </div>
            </>
          )}
          <div className="btn_block bottom_button d-flex justify-content-center">
            <button
              className="btn btn_primary"
              onClick={() =>
                onNextFn({
                  date: dobValue,
                  age: age,
                  minorConsent: isGuardianConsentProvided,
                })
              }
              disabled={!canProceed}
            >
              {t("login.DOBSTEP.button")}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default DOBInputStep;
